import React, { Component } from 'react';
import firebase from '../Firebase';
import { Link } from 'react-router-dom';

class Edit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      key: '',
      tutor:'',
      learner:'',
      subject:'',
      content:'',
      school:'',
      rating:0
    };
  }

  componentDidMount() {
    const ref = firebase.firestore().collection('tutorials').doc(this.props.match.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        const tutorial = doc.data();

        this.setState({
          key: doc.id,
          tutor: tutorial.tutor,
          learner: tutorial.learner,
          subject: tutorial.subject,
          content:tutorial.content,
          school:tutorial.school,
          rating:tutorial.rating
        });
      } else {
        console.log("No such document!");
      }
    });
  }

  onChange = (e) => {
    const state = this.state
    state[e.target.name] = e.target.value;
    this.setState({tutorial:state});
  }

  onSubmit = (e) => {
    e.preventDefault();

    const { tutor, learner, subject, content, school, rating} = this.state;

    const updateRef = firebase.firestore().collection('tutorials').doc(this.state.key);
    updateRef.set({
      tutor:tutor,
      learner:learner,
      subject:subject,
      content:content,
      school:school, 
      rating:rating,
    }).then((docRef) => {
      this.setState({
        key: '',
        tutor: '',
        learner: '',
        subject: '',
        content:'',
        school:'',
        rating:''
      });
      this.props.history.push("/show/"+this.props.match.params.id)
    })
    .catch((error) => {
      console.error("Error adding document: ", error);
    });
  }

  render() {
    return (
         
      <div>
          <nav class=" navbar navbar-dark bg-primary">
             <h3  class="navbar-brand mb-0 h1">Edit Tutorial Session for the learner:  {this.state.learner}</h3><br></br>
             <button class="btn btn-dark"><Link to="/list">Back to Sessions List</Link></button>
             <span  class="navbar-brand" ><Link to={`/show/${this.state.key}`} class="btn btn-success">Bact to Tutorial List</Link></span>
            </nav> <br/> <br/>
    

        <div class="container">
        
            <form onSubmit={this.onSubmit}>
            
            <div class="form-group">
                <input type="text" class="form-control" name="tutor" value={this.state.tutor} onChange={this.onChange} placeholder="Tutor" />
            </div>

            <div class="form-group">
                <input type="text" class="form-control" name="learner" value={this.state.learner} onChange={this.onChange} placeholder="Learner" />
            </div>

            <div class="form-group">
                <input type="text" class="form-control" name="subject" value={this.state.subject} onChange={this.onChange} placeholder="Subject" />
            </div>

            <div class="form-group">
            <textArea class="form-control" name="content" onChange={this.onChange} placeholder="Content" cols="80" rows="3">{this.state.content}</textArea>

            </div>

            <div class="form-group">
            <input type="text" class="form-control" name="school" onChange={this.onChange} value={this.state.school} placeholder="School" />
            </div>

            <div class="form-group">
            <label for="rating">Rating</label>
            <select class="form-control-select" name="rating" onChange={this.onChange} value={this.state.rating} placeholder="Rating">
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
                <option>6</option>
                <option>7</option>
                <option>8</option>
                <option>9</option>
                <option>10</option>
                </select>
            </div>
            <button type="submit"  class="btn btn-success">Submit updates</button>
            </form>
            <nav class="navbar navbar-dark bg-primary">
            <h6>© copyright My Tutor . All right reserved | 2019</h6>
            </nav>
          </div>
        </div>
     
          
    );
  }
}

export default Edit;